module.exports = __webpack_public_path__ + "static/media/ic_share_big_blue.6e8ca662.svg";